import { getHoursAndMinutesFromMinutes } from '@/utils';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Abweichung({ abweichung }: { abweichung: number }) {
  const { t } = useTranslation();

  const { hours, minutes } = getHoursAndMinutesFromMinutes(
    Math.abs(abweichung),
  );

  const formattedTime = `${String(Math.abs(hours)).padStart(2, '0')}:${String(
    Math.abs(minutes),
  ).padStart(2, '0')}`;

  return (
    <span
      className={`text-xs w-fit whitespace-nowrap rounded-md py-px px-2 flex gap-1 items-center ${
        Math.abs(abweichung) > 10
          ? 'text-primary-red-500 bg-primary-red-100'
          : ' bg-neutrals-300'
      }`}>
      {abweichung < 0 && <FontAwesomeIcon icon={faCaretDown} />}
      {abweichung > 0 && <FontAwesomeIcon icon={faCaretUp} />}
      {Math.abs(abweichung) === 0 ? (
        '--'
      ) : (
        <div className="flex gap-1 items-baseline">{formattedTime}</div>
      )}
      <span>{t('general.date.hours')}</span>
    </span>
  );
}
